import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router } from '@angular/router';
import { TemplateManagerService } from 'src/app/services/template-manager.service';
import { FormControl } from '@angular/forms';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ShipmentMonitorService } from 'src/app/services/shipment-monitor.service';
import { ClaimCenterGridConfigService } from 'src/app/data-grid/claim-center-grid-config.service';
import { updateShipmentDiscrepancy } from 'src/app/models/shipmentMonitor.model';
import { RefundAmountComponent } from 'src/app/components/dialogs/refund-amount/refund-amount.component';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { OpenCaseTemplateComponent } from 'src/app/components/dialogs/open-case-template/open-case-template.component';

@Component({
  selector: 'app-claim-center-tool-panel',
  templateUrl: './claim-center-tool-panel.component.html',
  styleUrls: ['./claim-center-tool-panel.component.scss']
})
export class ClaimCenterToolPanelComponent implements OnInit,OnDestroy {
  gridApi: GridApi;
  selectedClaim:any;
  copied;
  templates:any[] = [];
  note = new FormControl();
  selectedTemplate;
  isNote:boolean = false;
  private destroy$ = new Subject<void>();
  storeTemplateVar:any[] = [];
  claimStatus:any;
  selectedStatus;
  constructor(
    private gridActionService : GridActionsService,
    private router:Router,
    private templateManagerService:TemplateManagerService,
    private snackBar:MatSnackBar,
    private shipmentMonitor:ShipmentMonitorService,
    private claimCenterGridConfigService:ClaimCenterGridConfigService,
    private dialog:MatDialog
  ){}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
  }

  agInit(params:any){
    this.gridApi = params.api;   
    this.getTemplateVariables();
  }

  refresh(): void {
    if(this.selectedClaim?.shipmentDiscrepancyId !== this.gridActionService?.selectedClaimResponse?.ShipmentDiscrepancyId){
      this.selectedClaim = this.gridActionService.selectedClaimResponse;
      this.getShipmentDiscrepancy()
    }
  }

  getShipmentDiscrepancy(){
    this.shipmentMonitor.getShipmentDiscrepancy(this.selectedClaim.ShipmentDiscrepancyId).
    subscribe((res)=>{
      if(res){
        this.selectedClaim = res;
        this.selectedClaim.image= this.selectedClaim.imageUrl;
        this.selectedClaim.ShipmentId = this.selectedClaim.amazonShipmentId;
        this.claimStatus = this.claimCenterGridConfigService.claimStatus;
        let index =  this.claimStatus.findIndex((el) => el.caseStatusId == this.selectedClaim?.caseStatusId);
        if(index !== -1){
          this.selectedStatus = this.claimStatus[index];
        }
        const defaultTemplate = this.templates.filter((res) => res.isDefault);
        this.selectedTemplate = defaultTemplate.length > 0 ? defaultTemplate[0] : this.templates[0];
        this.selectedTemplate.formattedText = this.templateManagerService.formatVarNameWithValues(this.selectedClaim,this.selectedTemplate.templateText)
      }
    })
  }

  openLink(selectedRow) {
      this.router.navigate(['/shipyard/shipments/detail', selectedRow.ShipmentId])
  }

  copy(e) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  getTemplate(){
    this.templateManagerService.getTemplates().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if(res){
          this.templates = res;
          this.templates.forEach((res, i) => {
            if (res) {
              this.templates[i].templateText = this.templateManagerService.formatTempWithVarName(res.templateText);
            }
          });
        }
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      }
    })
  }           

  getTemplateVariables(){
    this.templateManagerService.getTemplateVariables().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if(res){
          this.storeTemplateVar = res;
          this.templateManagerService.storeTemplateVar=res;
          this.getTemplate();
        }
      },          
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      }
    })
  }

  showNote(){
    this.isNote = !this.isNote
    this.note.setValue(this.selectedClaim?.Note);
  }

  updateStatus(isDelete?,isNote?){
    const paylaod:updateShipmentDiscrepancy = {
    shipmentDiscrepancyId: this.selectedClaim.shipmentDiscrepancyId,
    isCaseCreated: false,
    caseStatusId: this.selectedClaim.caseStatusId,
    caseLink: isDelete ? null : this.selectedClaim.caseLink ,
    note: this.note.value ? this.note.value : this.selectedClaim.note,
    refundedAmount:this.selectedClaim.refundedAmount
    }
    this.shipmentMonitor.updateShipmentDiscrepancy(paylaod).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if(res){
          if(isDelete) this.selectedClaim.caseLink = null;
          if(isNote){
            this.selectedClaim.note = this.note.value;
            this.isNote = false;
          } 
        }
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Status has been updated successfully',
            action: 'Dismiss',
            type: 'success',
          },
        });
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
        }
     });
  }

  onChange(event){
    this.selectedClaim.caseStatusId = event.caseStatusId;
      this.updateStatus();
  }

   openDialog(isLink?){
    this.dialog.open(RefundAmountComponent, {
      width: "472px",
      data: {
        title:isLink ? 'Add Link': 'Refund Amount',
        isLink:isLink
      },
    }).afterClosed().subscribe((res)=>{
      if(res){
        if(res.link){
          this.selectedClaim.CaseLink = res.link;
        } 
        if(res.refundedAmount) {
          this.selectedClaim.refundedAmount = res.refundedAmount;
        }
        this.updateStatus();
      }
    })
  }

  cancel(){
    this.isNote = false;
    this.note.setValue(this.selectedClaim.note)
  }

  openCaseDialog(selectedClaim){
    this.dialog.open(OpenCaseTemplateComponent, {
      width: "601px",
      data: {
        title:'Open Case',
        actions: [
          { text: "Cancel"},
          { text: "Copy Text & Open Case"},
        ],
        params:selectedClaim,
      },
    }).afterClosed().subscribe((res)=>{

      if(res){
        selectedClaim.caseLink = res.caseLink;
        selectedClaim.note = res.note;
        selectedClaim.isCaseCreated = res.isCaseCreated;
      }
    });
  }

  openRefundAmount(isAmount?){
    this.dialog.open(RefundAmountComponent, {
      width: "472px",
      data: {
        title:'Refund Amount',
        amount:isAmount,
        isLink:false
      },
    }).afterClosed().subscribe((res)=>{
       if(res){
        if(res.refundedAmount) {
          this.selectedClaim.refundedAmount = res.refundedAmount;
        }
        this.updateStatus();
       }
    })
  }
}
